import { rangeWithFallbackBounds } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_YEAR = 1000;
const DEFAULT_MAX_YEAR = 9999;

export const lastFundingYearDescriptor = defineFilter({
  definition: {
    id: FilterId.LAST_FUNDING_YEAR,
    name: 'Last Funding Year',
    type: FilterType.RANGE,
    min: undefined,
    max: undefined,
    isActive: false,
    isVisible: true,
  },
  handler: rangeWithFallbackBounds(DEFAULT_MIN_YEAR, DEFAULT_MAX_YEAR),
});
